var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1014.05 983.28c-22.88-113.45-85.24-216.81-175.6-291a511.16 511.16 0 00-150-85.57q-8.52-3.09-17.12-5.89a321.19 321.19 0 10-318.74 0q-8.6 2.81-17.12 5.89a511.16 511.16 0 00-150 85.57C95.19 766.47 32.83 869.83 10 983.28a34 34 0 0066.66 13.44c19.79-98.15 73.81-187.61 152.1-251.92a446.68 446.68 0 01566.58 0c78.29 64.31 132.31 153.77 152.1 251.92a34 34 0 0066.66-13.44zM258.5 321.5a253.51 253.51 0 1174.25 179.25A251.84 251.84 0 01258.5 321.5z",
    fill: "#575757"
  })));
}
export default SvgMyBlack;